(function (root, factory) {
    'use strict';
    if (typeof exports === 'object') {
        // CommonJS
        module.exports = factory();
    } else if (typeof define === 'function' && define.amd) {
        // AMD
        define(function () {
            return factory();
        });
    } else if (typeof define === 'function' && define.cmd) {
        // CMD
        define(function (require, exports, module) {
            module.exports = factory();
        });
    } else {
        // Global Variables
        root.UEM = root.UEM || {};
        root.UEM.storage = factory();
    }
}(this, function () {
    'use strict';

    var win = window,
        doc = document,
        out = {};

    /**
     * 设置本地变量
     *
     * @param  {string} key 变量键值
     * @param  {object} o 变量对象
     * @return {boolean}
     */
    out.setLocal = function (key, o) {
        if (win.localStorage) {
            win.localStorage.setItem(key, JSON.stringify(o));
            return true;
        } else {
            return false;
        }
    };

    /**
     * 获取本地变量
     *
     * @param  {string} key 变量键值
     * @return {object} 变量对象
     */
    out.getLocal = function (key) {
        if (win.localStorage) {
            var jsonStr = win.localStorage.getItem(key);
            if (jsonStr) {
                return JSON.parse(jsonStr);
            } else {
                return null;
            }
        } else {
            return null;
        }
    };

    /**
     * 设置会话变量
     *
     * @param  {string} key 变量键值
     * @param  {object} o 变量对象
     * @return {boolean}
     */
    out.setSession = function (key, o) {
        if (win.sessionStorage) {
            win.sessionStorage.setItem(key, JSON.stringify(o));
            return true;
        } else {
            return false;
        }
    };

    /**
     * 获取会话变量
     *
     * @param  {string} key 变量键值
     * @return {object} 变量对象
     */
    out.getSession = function (key) {
        if (win.sessionStorage) {
            var jsonStr = win.sessionStorage.getItem(key);
            if (jsonStr) {
                return JSON.parse(jsonStr);
            } else {
                return null;
            }
        } else {
            return null;
        }
    };

    /**
     * 设置cookie变量
     *
     * @param  {string} key 变量键值
     * @param  {string} o 变量对象
     * @return {boolean}
     */
    out.setCookie = function (key, value, expiredays) {
        var exdate = new Date();
        exdate.setDate(exdate.getDate() + expiredays);
        doc.cookie = key + '=' + win.escape(value) +
            ((expiredays == null) ? '' : ';expires=' + exdate.toGMTString());
    };

    /**
     * 获取cookie变量
     *
     * @param  {string} key 变量键值
     * @return {string} 变量对象
     */
    out.getCookie = function (key) {
        if (doc.cookie.length > 0) {
            var start = doc.cookie.indexOf(key + '=');
            if (start !== -1) {
                start = start + key.length + 1;
                var end = doc.cookie.indexOf(';', start);
                if (end === -1) {
                    end = doc.cookie.length;
                }
                return win.unescape(doc.cookie.substring(start, end));
            }
        }
        return '';
    };

    /**
     * 清除所有session变量
     *
     * @return {boolean}
     */
    out.clearSession = function () {
        if (win.sessionStorage) {
            win.sessionStorage.clear();
            return true;
        } else {
            return false;
        }
    };

    /**
     * 清除所有local变量
     *
     * @return {boolean}
     */
    out.clearLocal = function () {
        if (win.localStorage) {
            win.localStorage.clear();
            return true;
        } else {
            return false;
        }
    };

    /**
     * 清除所有local变量
     *
     * @return {boolean}
     */
    out.deleteCookie = function (key) {
        doc.cookie = key + '=;expires=' + (new Date(0)).toGMTString();
    };
    
    return out;
}));
